
import { IntlLoader } from 'apprise-frontend-core/intl/loader';
import { StateProvider } from 'apprise-frontend-core/state/provider';
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard';
import { IntlConfiguration } from './config';
import { InltContext, initialIntlState, useIntl } from './state';

export type IntlProps = React.PropsWithChildren<Partial<IntlConfiguration>>


// mounts state, if we haven't already, then initialise configuration and loads trnaslations.
export const Intl = (props: IntlProps) => {

    const { children, ...rest } = props

    return <StateProvider initialState={initialIntlState} context={InltContext}>
        <IntlInitialiser {...rest}>
            <IntlLoader {...rest}>
                {children}
            </IntlLoader>
        </IntlInitialiser>
    </StateProvider>

}



const IntlInitialiser = (props: IntlProps) => {

    const intl = useIntl()

    const { children, ...config } = props
    

    // activates module before rendering children.
    const { content } = useRenderGuard({

        render: children,

        orRun: () => intl.init(config)
    })

    return content
}
